export default "__VITE_ASSET__1P$11OPY__"